import Player from '@vimeo/player';

(function ($) {
    $(document).ready(function () {
        $("img[data-vimeo-id]").each(function (index) {
            var vimeoId = $(this).data('vimeo-id');
            // Endpoint: https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/
            $.getJSON('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + vimeoId, {
                    format: "json",
                    width: "640"
                },
                function (data) {
                    $("img[data-vimeo-id=" + vimeoId + "]").attr('src', data.thumbnail_url);
                });
        });

        class CustomPlayers {
            init(selector, width) {
                this.players = [];
                this.selector = selector;

                width = width || 616;
                $(selector).each((index, item) => {
                    let videoWrapper = $(item).find('.video-vimeo');
                    let videoID = $(item).find('.video-inner').attr('data-vid');
                    const player = new Player(videoWrapper.get(0), {
                        id: videoID,
                        width: width,
                        controls: true,
                        loop: true,
                        autopause: true,
                    });

                    this.players.push({
                        instance: player,
                        el: videoWrapper.get(0),
                    });
                });

                this.createListeners();
            }

            createListeners() {
                this.players.forEach((item, index) => {
                    $(item.el).closest(this.selector).find('.logo-play, .text_button').on('click', (e) => {
                        e.preventDefault();
                        // console.log("click", item.instance);
                        let player = item.instance;
                        // $('.logo-play').fadeIn(300);
                        // $('.image-video').fadeOut(300);
                        player.getPaused().then((paused) => {
                            if (paused) {
                                player.play();
                                $(e.target).closest(this.selector).find('.logo-play').fadeOut(300);
                                $(e.target).closest(this.selector).find('.image-video').fadeOut(300);
                            }
                        });
                    });

                    $(item.el).closest(this.selector).find('.logo-pause').on('click', (e) => {
                        e.preventDefault();
                        // console.log("click pause", item.instance);
                        let player = item.instance;

                        player.getPaused().then((paused) => {
                            if (!paused) {
                                player.pause();
                                $(e.target)
                                    .closest(this.selector)
                                    .find('.logo-play')
                                    .fadeIn(300);
                            } else {
                                player.getAutopause().then((paused) => {
                                    if (paused) {
                                        player.play();
                                        $('.logo-play').fadeIn(300);
                                        $(e.target).closest(this.selector).find('.logo-play').fadeOut(300);
                                        // console.log('play video')
                                    }
                                });
                            }
                        });
                    });
                });
            }
        }

        // let postsPlayers = new CustomPlayers();
        // postsPlayers.init('.item_posts_for_video', 349);
         //console.log(postsPlayers);

        // let mainPlayer = new CustomPlayers();
        // mainPlayer.init('.section_video_and_document');
        // console.log(mainPlayer);
    });
})(jQuery);